import React from 'react';
import { Form, Input, Button, Card, Spin } from 'antd';
import { useTypedSelector } from '../store';
import { useDispatch } from 'react-redux';
import { loginRequest } from '../slices/auth';
import { LoadingOutlined } from '@ant-design/icons';
import { Navigate } from 'react-router-dom';

interface LoginProps {
  onLogin: (values: { employeeId: string; password: string }) => void;
}

const Login: React.FC = () => {
  const dispatch = useDispatch();
  const {message, isLogin, loading} = useTypedSelector((state) => {
    return {
      message: state.Auth.message,
      isLogin: state.Auth.isLogin,
      loading: state.Auth.pageIsLoading
    }
  })
  const onFinish = (values: { employeeId: string; password: string }) => {
    console.log('Login data:', values);
    dispatch(loginRequest(values) as any)

    // onLogin(values);

  };

  if(isLogin){
    return <Navigate to="/" replace />
  }

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 'auto' }}>
      <Card title="Login" style={{ width: 300 }}>
        <Form
          name="loginForm"
          onFinish={onFinish}
          layout="vertical"
          autoComplete="off"
        >
          <Form.Item
            label="Employee ID"
            name="employeeId"
            rules={[{ required: true, message: 'Please input your Employee ID!' }]}
          >
            <Input placeholder="Enter your Employee ID" />
          </Form.Item>

          <Form.Item
            label="Password"
            name="password"
            rules={[{ required: true, message: 'Please input your password!' }]}
          >
            <Input.Password placeholder="Enter your password" />
          </Form.Item>

          <Form.Item>
            {loading && (<><Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}  /></>)}
            {message.length > 0 && (<p style={{color: "red"}}>{message}</p>)}
            <Button type="primary" htmlType="submit" style={{ width: '100%' }}>
              Login
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default Login;
